export default "__VITE_ASSET__Lr4ty7fD__"